export interface Repo {
  installationId: number;
  fullName: string;
}

export function parseRepoKey(key: string): {
  installationId: number;
  repoFullName: string;
} {
  let k = key;
  if (k.startsWith('github:')) k = k.slice(7);
  const sepIdx = k.indexOf(':');
  if (sepIdx === -1) {
    return { installationId: NaN, repoFullName: k };
  }
  return {
    installationId: Number(k.slice(0, sepIdx)),
    repoFullName: k.slice(sepIdx + 1),
  };
}

export function toRepoKey(repo: { installationId?: number; fullName: string }): string {
  return `${repo.installationId ?? 0}:${repo.fullName}`;
}

export function repoCountLabel(count: number): string {
  return count === 1 ? '1 repository' : `${count} repositories`;
}
